import { GET, POST, POSTNEW, download, UPLOADINGNEW, uploading, POSTFormData, EXPORTNEW, uploadingImg, DELETENEW, GETNEW, POSTFormDataNEW } from '@/request/http'

// 获取指定菜单下具有的按钮权限
export const getButtonPermissions = p => GETNEW('/basic/sys-permission/find/permission/function', p)

// 获取部门树
export const getDepartmentTree = p => POSTNEW('/basic/office/findCompanyOfficeTree', p)

// 组织管理表格
export const getOrganizationList = p => POSTNEW('/basic/office/page', p)

// 新增部门
export const submitAddOrganization = p => POSTNEW('/basic/office/save', p)

// 删除部门
export const deleteDepartment = p => POSTNEW('/basic/office/remove', p)


// 获取岗位列表（分页）
export const getSettingPostList = p => POSTNEW('/basic/post/page', p)

// 新增岗位
export const submitAddPost = p => POSTNEW('/basic/post/save', p)

// 删除岗位
export const submitDelPost = p => POSTNEW('/basic/post/remove', p)

// 获取数据权限树
export const getDataPermissionsTree = p => GETNEW('/basic/office-permission/findCheckOfficeTree/POST', p)

// 获取菜单权限树
export const getMenuPermissionsTree = p => GETNEW('/basic/post-permission/getSysPermissionTree', p)

// 提交数据权限
export const submitDataPermissions = p => POSTNEW('/basic/office-permission/save', p)

// 提交菜单权限
export const submitMenuPermissions = p => POSTNEW('/basic/post-permission/save', p)

// 获取人员管理表头字段
export const getPersonnelHeader = p => GETNEW('/basic/query-config/HQ_EMPLOYEE_OPERATOR_PAGE/findFieldList', p)

// 人员管理分页
export const getPersonnelPage = p => POSTNEW('/basic/employee/page', p)

// 获取人员管理新增人员字段
export const getAddPersonnelField = p => GETNEW('/basic/employee/findField/PC_EMPLOYEE_DETAIL', p)

//获取岗位列表
export const getFindList = p => GETNEW('/basic/post/findList', p)

// 新增人员接口
export const addPersonnel = p => POSTNEW('/basic/employee/save/PC_EMPLOYEE_DETAIL', p)

// 获取数据权限树(人员管理)
export const getDataPermissionsTreeEMPLOYEE = p => GETNEW('/basic/office-permission/findCheckOfficeTree/EMPLOYEE', p)

// 批量操作
export const saveBatchPost = p => POSTNEW('/basic/employee/saveBatchPost', p)

// 删除人员
export const deletePersonnel = p => POSTNEW('/basic/employee/remove', p)


// WEBPACK FOOTER //
// ./src/api/modules/systemSettings.js